export default __webpack_public_path__ + "static/gallery1-e47205ba054ebf9fd657c3fdf88e5961.jpg";